/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

var icon_signal_cellular_connected_no_internet_2_bar = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill-opacity=".3" d="M22 8V2L2 22h16V8z"/><path d="M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"/></svg>';
export { icon_signal_cellular_connected_no_internet_2_bar };
